import { Switch } from "@headlessui/react";
import clsx from "clsx";

import { DeviceStatusIndicator } from "@/components/Portal/components/PortalDeviceList/DeviceListRow/DeviceStatusIndicator/DeviceStatusIndicator";

interface StatusProps {
  statusColor: any;
  statusLabel: string;
  enabled: boolean;
  onChange: (checked: boolean) => void;
}

export const StatusChip = ({
  statusColor,
  statusLabel,
  enabled,
  onChange,
}: StatusProps) => {
  return (
    <Switch
      checked={enabled}
      onChange={onChange}
      className={clsx(
        "relative flex cursor-pointer items-center gap-2 rounded-md px-3 py-2.5 text-foreground-primary-inverse transition-colors",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foreground-primary-inverse",
        "disabled:cursor-not-allowed disabled:opacity-40",
        enabled
          ? "[&:hover,&:active]:bg-surface-secondary-inverse bg-surface-tertiary-inverse"
          : "[&:hover,&:active]:bg-surface-tertiary-inverse",
      )}
    >
      {enabled && (
        <span className="absolute left-1 top-1/2 h-4 w-0.5 -translate-y-1/2 rounded-full bg-foreground-primary-inverse" />
      )}
      <DeviceStatusIndicator color={statusColor} className="h-5 w-5 shrink-0" />
      <span className="text-base font-semibold leading-none tracking-wide">
        {statusLabel}
      </span>
    </Switch>
  );
};
